module.exports = __webpack_public_path__ + "img/mobile_parked.e29cde76.svg";